import script from "./UserPgMoshikomi.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPgMoshikomi.vue?vue&type=script&setup=true&lang=js"

import "./UserPgMoshikomi.vue?vue&type=style&index=0&id=b73581d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b73581d4"]])

export default __exports__